"use client";

import Image from "next/image";
import LeftArrowWhiteCircleIcon from "~/icons/left-arrow-white-circle.svg";
import styles from "./SpecializationCard.module.scss";
import Markdown from "@/components/atoms/Markdown";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";
import Carousel from "../CustomCarousels/Carousel";

type Specialization = {
  Image?: {
    enabled: boolean;
    source?: {
      data?: Array<{ attributes: { url: string } }>;
    };
    alt?: string;
    url?: string;
    title?: string;
  };
  Title?: {
    enabled: boolean;
    text: string;
  };
  SponsoredImage?: {
    data?: {
      attributes: {
        url: string;
      };
    };
  };
};


export function SpecializationCard({
  SlideContent,
  index,
}: {
  SlideContent: Specialization;
  index?: number;
}) {

  const title = SlideContent?.Title?.text.replace(/\n/gi, "  \n");

  const GAEventsHandler = () => {
    pushToDataLayer({
      'event': 'card_interaction',
      'cta_text': title,
      'section_name': 'Key Specializations',
      'page_type': getGlobalStateValue('pageType')
    });
  }

  return (
    <div id={`specialization-card-${index}`}
      className={`${styles.SpecializationCard__background} flex flex-col justify-between`}
    >
      {SlideContent?.Image?.enabled && (
        <div className={`${styles.SpecializationCard__InnerImage}, flex justify-between`}>
          <Image
            src={SlideContent?.Image?.source?.data?.[0]?.attributes?.url}
            alt={SlideContent?.Image?.alt || 'Specialization Card'}
            width={60}
            height={60}
            title="Specialization Card"
          />
          {SlideContent?.SponsoredImage?.data?.attributes?.url && (
            <div className={styles['sponsored-image-wrapper']}>
              <Image
                src={SlideContent?.SponsoredImage?.data?.attributes.url}
                alt="logo"
                width={80}
                height={60}
                title="logo"
                className={styles['sponsored-image']}
              />
            </div>
          )
          }
        </div>
      )}

      <div className="flex items-center justify-between gap-2">
        {SlideContent?.Title?.enabled && (
          <h3 className={`${styles.SpecializationCard__InnerTitle} font-semibold`}
          >
            <Markdown>
              {title}
            </Markdown>
          </h3>
        )}
        {!!SlideContent?.Image?.url && (
          <a
           id={`specialization-card-cta-${index }`}
            onClick={GAEventsHandler}
            href={SlideContent?.Image?.url || ""}
            title={
              SlideContent?.Image?.title ||
              SlideContent?.Title?.text?.replace(/\n/gi, "")
            }

          >
            <div
              className={`shrink-0 ${styles.SpecializationCard__InnerShowMoreIcon}
        font-semibold`}
            >
              <Image src={LeftArrowWhiteCircleIcon} alt="show more" title="show more" />
            </div>
          </a>
        )}
      </div>
    </div>
  );
}

export default function SpecializationCarousel({
  data,
}: {
  data: SpecializationAttributes[];
}) {

  return (
    <div id="Carousel">
      <Carousel
      id = "KeySpecializations"
        children={data?.map((slideContent: SpecializationAttributes, index: number) => (
          <div key={index} className={styles.specialCardWrapper}>
            <SpecializationCard SlideContent={slideContent.attributes} index={index}/>
          </div>
        ))}
        config={{
          spaceBetween: 20,
          autoplay: {
            delay: 2000
          },
          speed: 500,
          pagination: {
            className: "program_detail_carousel_pagination text-center my-5",
          },
          breakpoints: {
            320: {
              slidesPerView: 1.1,
            },
            481: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 3.1,
              spaceBetween: 15,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 5,
              spaceBetween: 25,
            },
            1900: {
              slidesPerView: 5,
              spaceBetween: 30,
            },
            2560: {
              slidesPerView: 5,
              spaceBetween: 40,
            }
          },
        }}
        className={styles.specializationsCarousel}
      />
    </div>
  );
}
